import { Triangle, Hexagon, Zap, Shield, Activity, Target, TrendingUp, Globe, Gauge, BarChart3, CandlestickChart, Layers } from "lucide-react";

const ICONS = {
  Triangle, Hexagon, Zap, Shield, Activity, Target, TrendingUp, Globe, Gauge, BarChart3, CandlestickChart, Layers,
};

export default function FirmIcon({ name, size = 22, logo }) {
  if (logo) {
    return <img src={logo} alt="" className="h-full w-full rounded-[inherit] object-cover" />;
  }
  const Icon = ICONS[name] || Activity;
  return <Icon size={size} strokeWidth={1.75} className="text-signal" />;
}
